// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $def  = require('./$.def');

$def($def.P, 'Set', {toJSON: require('./$.collection-to-json')('Set')});


/** WEBPACK FOOTER **
 ** ./~/react-native-winjs/~/core-js/library/modules/es7.set.to-json.js
 **/